<p-dialog [header]="dialogData.title" [(visible)]="display" [dismissableMask]="true">
  {{ dialogData.message }}
</p-dialog>
<router-outlet></router-outlet>

<div class="projul-global-loader" *ngIf="isLoading">
  <img src="../assets/projul-loader.gif" alt="Loading....">
</div>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [style]="{width: '40vw'}"></p-confirmDialog>

<p-toast></p-toast>